module.exports = __webpack_public_path__ + "img/voice-icon15.c7ceee1.png";